import React from "react";
import { PagesBanner } from "../components/PagesBanner";
import {
  aboutUsDescriptionLabel,
  aboutUsLabel,
} from "../constants/translations";
import { BannerImg } from "../assets/photos";
import { OurStory } from "../components/OurStory";

export const AboutUsPage = ({ languageId }) => {
  return (
    <>
      <PagesBanner
        title={aboutUsLabel[languageId].label}
        description={aboutUsDescriptionLabel[languageId].label}
        image={BannerImg}
      />

      <OurStory languageId={languageId} />
      {/* <AboutUsContent /> */}
    </>
  );
};
